import Vue from 'vue'
import Vuex from 'vuex'
import { ReferralsState, ReferralsModule } from '@/store/referrals'
import { OrdersState, OrdersModule } from '@/store/orders'
import { ProjectsState, ProjectsModule } from '@/store/projects'
import { UiState, UiModule } from '@/store/ui'
import { TriggeredActionState, TriggeredActionModule } from '@/store/triggeredActions'
import { TriggeredReferralState, TriggeredReferralModule } from '@/store/triggeredReferrals'
import { PrintedDocumentState, PrintedDocumentModule } from '@/store/printedDocuments'
import { RealworksStatusRuleState, RealworksStatusRuleModule } from '@/store/realworksStatusRules'
import { PipelineConnectionsModule, PipelineConnectionsState } from '@/store/pipelineConnections'
import { SmartMarketingModule, SmartMarketingState } from '@/store/smartMarketing'


Vue.use(Vuex)

export interface RootState {
    referrals: ReferralsState,
    orders: OrdersState,
    pipelineConnections: PipelineConnectionsState,
    projects: ProjectsState,
    ui: UiState,
    triggeredAction: TriggeredActionState,
    triggeredReferral: TriggeredReferralState,
    printedDocument: PrintedDocumentState,
    realworksStatusRule: RealworksStatusRuleState,
    smartMarketing: SmartMarketingState,
}

export default new Vuex.Store({
    modules: {
        referrals: ReferralsModule,
        orders: OrdersModule,
        pipelineConnections: PipelineConnectionsModule,
        projects: ProjectsModule,
        ui: UiModule,
        triggeredAction: TriggeredActionModule,
        triggeredReferral: TriggeredReferralModule,
        printedDocument: PrintedDocumentModule,
        realworksStatusRule: RealworksStatusRuleModule,
        smartMarketing: SmartMarketingModule,
    },
})
